import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions } from '@mui/material';
import { useGroups } from '@app/api/groups/useGroups';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { ListData, CounterTag } from '@shared/ui/parts';
import { getTotalCards } from '@utils/helpers';
//todo: decline rate временно закомментирован, пока нет в api

export default function UnfreezeTeamDialog({ close, data }) {
  const { t } = useTranslation();
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();

  const { unfreezeGroup } = useGroups();

  async function onSubmit() {
    await unfreezeGroup({
      group_id: data.id,
      decline_rate: 1,
    });
    close();
  }

  return (
    <>
      <DialogContent>
        <div className="form">
          <p>{t('are_you_sure_unfreeze_team')}</p>
          <CounterTag data={data} iconType="members" />
          <ListData
            listData={[
              {
                label: t('team_cards'),
                value: getTotalCards(data),
              },
              // {
              //   label: t('current_decline_rate'),
              //   value: data.decline_rate + '%',
              // },
            ]}
          />
          {/* <FormGroup label={t('new_decline_rate_limit')}>
            <Controller
              control={control}
              name="decline_rate"
              render={({ field }) => (
                <div className="decline-rate-slider">
                  <p className="body-18r">{field.value}%</p>
                  <Slider
                    progress
                    min={3}
                    max={20}
                    value={field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                </div>
              )}
            />
          </FormGroup> */}
        </div>
        <Note
          marginTop
          type="warning"
          title={t('important')}
          content={t('unfreeze_team_note')}
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon="unfreeze"
            onClick={handleSubmit(onSubmit)}
            loading={isSubmitting}
          >
            {t('yes_unfreeze')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
